export const GET_GAS_PRICE = "coinshift/gas/GET_GAS_PRICE";
export const GET_GAS_PRICE_SUCCESS = "coinshift/gas/GET_GAS_PRICE_SUCCESS";
export const GET_GAS_PRICE_ERROR = "coinshift/gas/GET_GAS_PRICE_ERROR";

export const SET_SELECTED_GAS_PRICE = "coinshift/gas/SET_SELECTED_GAS_PRICE";

export const RESTART_GAS_PRICE = "coinshift/gas/RESTART_GAS_PRICE";
